import React, {
  useState,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import "./moodboardMediaView.css";
import ReactJWPlayer from "react-jw-player";
import ContentComments from "../ContentComments";
import moodBoardService from "../../services/moodboard";
import { IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import ReactPlayer from "react-player";
import { Image, Spin } from "antd";
import YoutubePlayer from "../YoutubePlayer/YoutubePlayer";
import IspotPlayer from "../IspotPlayer/IspotPlayer";
import { InstagramEmbed } from "react-social-media-embed";
import LinkedInCard from "../LinkedInCard";

const MoodboardMediaView = forwardRef(({ selectedIndex = 1, data }, ref) => {
  const viewPort = document.getElementById("root");
  const carouselItemWidth = viewPort.clientWidth / 5;
  const carouselItemHeight = viewPort.clientHeight / 6.5;

  let t = selectedIndex - 1;
  const [index, setIndex] = useState(t);
  const [showComment, setShowComment] = useState(false);
  const [disablePrevious, setDisablePrevious] = useState(t > 1 ? false : true);
  const [disableNext, setDisableNext] = useState(
    t === data.length ? true : false
  );
  const [isInitted, setIsInitted] = useState(false);
  const [selectedMoodboard, setSelectedMoodboard] = useState(data[t]?._id);

  useEffect(() => {
    setIsInitted(true);
  }, []);

  useEffect(() => {
    renderDisplaying();
    manageButtons();
    let t = data[index];
    if (t) setSelectedMoodboard(t._id);
  }, [index]);

  const onToggleComment = () => {
    setShowComment(!showComment);
  };

  useImperativeHandle(ref, () => ({
    onToggleComment: () => {
      onToggleComment();
    },
  }));

  useEffect(() => {
    function handlekeydownEvent(event) {
      const { key, keyCode } = event;
      if (keyCode == 37 && index > 0) {
        goPrevious();
      }
      if (keyCode == 39 && index < data.length - 1) {
        goNext();
      }
    }

    document.addEventListener("keyup", handlekeydownEvent);
    return () => {
      document.removeEventListener("keyup", handlekeydownEvent);
    };
  }, [index]);

  const renderDisplaying = () => {
    const item = data[index];
    const type = item?.type;
    const playingUrl = item?.fileUrl;
    if (type === "video") {
      if (playingUrl.includes("ispot.tv")) {
        return (
          <IspotPlayer
            url={playingUrl}
            style={{
              maxHeight: "550px",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            className="ispot-player-media-view"
          />
        );
      } else if (playingUrl.includes("youtube.com/shorts")) {
        return (
          <YoutubePlayer
            url={playingUrl}
            style={{ maxHeight: "550px", height: "100%", width: "100%" }}
          />
        );
      } else if (playingUrl.includes("youtube")) {
        let id = new URL(playingUrl).searchParams.get("v");
        let src = `https://www.youtube.com/embed/${id}`;
        return (
          <iframe
            id="player"
            className="media-view-embed"
            src={src}
            key={playingUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      } else if (item.source === "instagram") {
        return <InstagramEmbed key={playingUrl} url={playingUrl} />;
      } else if (item.source === "twitter") {
        const tweetId = playingUrl.match(/status\/(\d+)/)?.[1];
        return tweetId ? (
          <iframe
            src={`https://platform.twitter.com/embed/Tweet.html?id=${tweetId}&theme=dark`}
            className="media-view-embed"
            style={{ border: "none", minHeight: "400px" }}
            allowFullScreen
          />
        ) : null;
      } else if (item.source === "linkedin") {
        return <LinkedInCard key={playingUrl} url={playingUrl} />;
      } else if (playingUrl.includes("vimeo")) {
        let id = playingUrl.split("/").pop();
        let src = `https://player.vimeo.com/video/${id}`;
        return (
          <iframe
            id="player"
            className="media-view-embed"
            src={src}
            key={playingUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        );
      } else {
        return (
          <ReactPlayer
            className="media-view-player"
            id={playingUrl.toString()}
            url={playingUrl}
            controls={true}
          />
        );
      }
    } else if (type === "docs") {
      return (
        <iframe
          id="player"
          className="player"
          style={{ width: "830px", height: "60vh" }}
          src={playingUrl}
          key={playingUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      );
    } else if (type === "audio") {
      return (
        <div style={{ margin: "20px", marginTop: "100px" }} key={playingUrl}>
          <audio
            controls
            className="audio-player w-100"
            src={playingUrl}
          ></audio>
        </div>
      );
    } else if (type === "image") {
      return (
        <img
          className="image-player"
          style={{ maxHeight: "550px" }}
          key={playingUrl}
          src={playingUrl}
        />
      );
    } else if (type === "website") {
      return (
        <>
          <img
            className="image-player mb-30"
            key={playingUrl}
            src={playingUrl}
          />
          <br />
          Title: {item.title}
          <br />
          Website:{" "}
          <a href={item.websiteUrl} target="_blank" className="btn btn-link">
            {item.websiteUrl}
          </a>
          <br />
          Description: {item.description}
        </>
      );
    } else if (type === "pexels-video") {
      // return <video className="player" key={playingUrl} controls>
      //     <source src={playingUrl} type="video/mp4"/>
      // </video>
      return (
        <ReactPlayer
          className="media-view-player"
          id={playingUrl.toString()}
          url={playingUrl}
          controls={true}
        />
      );
    }
  };

  const goPrevious = (e) => {
    //e.preventDefault();
    if (index > 0) {
      setIndex(index - 1);
      goToSlide(index - 1);
    }

    manageButtons();
  };

  const goNext = (e) => {
    //e.preventDefault();
    if (index < data.length) {
      setIndex(index + 1);
      goToSlide(index + 1);
    }

    manageButtons();
  };

  const manageButtons = () => {
    setDisablePrevious(true);
    setDisableNext(true);
    if (index > 0) setDisablePrevious(false);
    if (index < data.length - 1) setDisableNext(false);
  };

  const goToSlide = (newIndex) => {
    setIndex(newIndex);
    const carousel = document.getElementsByClassName("reel-list")[0];

    const nextImageIndex = carouselItemWidth * newIndex;
    carousel.style.transform = `translateX(-${nextImageIndex}px)`;
  };

  if (data?.length === 0 || !isInitted) {
    return null;
  }

  return (
    <div className="container-fluid text-center mt-20 media-view">
      <div className="container-fluid content-details">
        <div className="row media-main-content">
          <div className="col-1 text-center">
            <IconButton
              className={`nav-button left-nav-icon`}
              disabled={disablePrevious}
              onClick={goPrevious}
            >
              <ChevronLeft />
            </IconButton>
          </div>
          <div
            className="col-md-7 col-sm-12 text-left media-view-body-content-wrapper"
            style={{ flex: 1, maxWidth: "100%", height: "100%" }}
          >
            <div className="media-view-body-content">
              {data && renderDisplaying()}
            </div>
          </div>
          {showComment && (
            <div
              className="col-md-3 col-sm-12 text-left"
              style={{
                paddingLeft: "20px",
                marginTop: "50px",
                alignSelf: "flex-start",
              }}
            >
              <ContentComments id={selectedMoodboard} />
            </div>
          )}
          <div className="col-1 text-center">
            <IconButton
              className={`nav-button`}
              disabled={disableNext}
              onClick={goNext}
            >
              <ChevronRight />
            </IconButton>
          </div>
        </div>
        <div className="reel-list">
          {data.map((media, i) => {
            if (
              media.thumbnailUrl?.length > 0 &&
              !media.thumbnailUrl.includes("null")
            ) {
              return (
                <div
                  className={`reel-item ${i === index && "reel-item-active"}`}
                  key={media._id}
                >
                  <Image
                    width={carouselItemWidth}
                    height={carouselItemHeight}
                    src={media.thumbnailUrl}
                    preview={false}
                    onClick={() => goToSlide(i)}
                  />
                </div>
              );
            } else if (media.fileUrl.includes("ispot.tv")) {
              return (
                <div
                  className={`${i === index && "reel-item-active"}`}
                  style={{ display: "flex", position: "relative" }}
                  onClick={() => goToSlide(i)}
                  key={media._id}
                >
                  <IspotPlayer
                    url={media.fileUrl}
                    style={{
                      pointerEvents: "none",
                      height: carouselItemHeight,
                      width: carouselItemWidth,
                      position: "static",
                    }}
                    className="ispot-thumbnail-media-view"
                  />
                </div>
              );
            } else if (
              media.type === "video" &&
              (media.fileUrl.includes("youtube.com") ||
                media.fileUrl.includes("youtu.be"))
            ) {
              const videoId =
                new URL(media.fileUrl).searchParams.get("v") ||
                new URL(media.fileUrl).pathname.split("/")[1];
              return (
                <div
                  className={` ${i === index && "reel-item-active"}`}
                  style={{
                    display: "flex",
                    position: "relative",
                  }}
                  onClick={() => goToSlide(i)}
                  key={media._id}
                >
                  <iframe
                    id="player"
                    className="pointerEventNone"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    key={`https://www.youtube.com/embed/${videoId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    height={carouselItemHeight}
                    width={carouselItemWidth}
                  ></iframe>
                </div>
              );
            } else if (
              media.type === "video" &&
              media.fileUrl.includes("vimeo.com")
            ) {
              const videoId = media.fileUrl.split("/").pop();
              return (
                <div
                  className={`${i === index && "reel-item-active"}`}
                  onClick={() => goToSlide(i)}
                  key={media._id}
                >
                  <iframe
                    id="player"
                    className="pointerEventNone"
                    src={`https://player.vimeo.com/video/${videoId}`}
                    key={`https://player.vimeo.com/video/${videoId}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    height={carouselItemHeight}
                  ></iframe>
                </div>
              );
            } else if (media.type === "image") {
              return (
                <div
                  className={`reel-item ${i === index && "reel-item-active"}`}
                  key={media._id}
                >
                  <Image
                    width={carouselItemWidth}
                    height={carouselItemHeight}
                    fallback={`data:image/png;base64,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`}
                    src={media.fileUrl}
                    onClick={() => goToSlide(i)}
                  />
                </div>
              );
            } else if (media.source === "instagram") {
              return (
                <div
                  className={`reel-item ${i === index && "reel-item-active"}`}
                  key={media._id}
                >
                  <Image
                    width={carouselItemWidth}
                    height={carouselItemHeight}
                    preview={false}
                    src={
                      "https://cdn.digitbin.com/wp-content/uploads/How-to-Send-Silent-and-Disappearing-Messages-on-Instagram.png"
                    }
                    onClick={() => goToSlide(i)}
                  />
                </div>
              );
            } else if (media.source === "twitter") {
              return (
                <div
                  className={`reel-item ${i === index && "reel-item-active"}`}
                  key={media._id}
                >
                  <Image
                    width={carouselItemWidth}
                    height={carouselItemHeight}
                    preview={false}
                    src="https://abs.twimg.com/icons/apple-touch-icon-192x192.png"
                    onClick={() => goToSlide(i)}
                  />
                </div>
              );
            } else if (media.source === "linkedin") {
              return (
                <div
                  className={`reel-item ${i === index && "reel-item-active"}`}
                  key={media._id}
                >
                  <Image
                    width={carouselItemWidth}
                    height={carouselItemHeight}
                    preview={false}
                    src="https://static.licdn.com/aero-v1/sc/h/al2o9zrvru7aqj8e1x2rzsrca"
                    onClick={() => goToSlide(i)}
                  />
                </div>
              );
            }

            return (
              <div
                className={`reel-item ${i === index && "reel-item-active"}`}
                key={media._id}
              >
                <Image
                  width={carouselItemWidth}
                  height={carouselItemHeight}
                  preview={false}
                  src="https://d33v4339jhl8k0.cloudfront.net/docs/assets/591c8a010428634b4a33375c/images/5ab4866b2c7d3a56d8873f4c/file-MrylO8jADD.png"
                  onClick={() => goToSlide(i)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default MoodboardMediaView;
